import request from '@/plugins/axios'

//获取列表
export function listWorkgroup(params) {
  return request({
    url: '/workgroup/listWorkgroup',
    method: 'get',
    params
  })
}

//获取指定工作圈的关联信息列表
export function listAccessByWorkgroupId(params) {
  return request({
    url: '/workgroup/listAccessByWorkgroupId',
    method: 'get',
    params
  })
}

//获取指定用户的工作圈的关联信息列表
export function listAccessByUid(params) {
  return request({
    url: '/workgroup/listAccessByUid',
    method: 'get',
    params
  })
}

//添加
export function addWorkgroup(data) {
  return request({
    url: '/workgroup/addWorkgroup',
    method: 'post',
    data
  })
}

//删除
export function deleteWorkgroup(params) {
  return request({
    url: '/workgroup/deleteWorkgroup/' + params,
    method: 'get'
  })
}

//查询单个
export function getWorkgroup(params) {
  return request({
    url: '/workgroup/getWorkgroup/' + params,
    method: 'get'
  })
}

//修改
export function updateWorkgroup(data) {
  return request({
    url: '/workgroup/updateWorkgroup',
    method: 'post',
    data
  })
}


//设置记录
export function setAccess(params) {
  return request({
    url: '/workgroup/setAccess',
    method: 'post',
    params
  })
}
